import React, { useRef } from "react";
import { CustomLabel, ProductListContainer } from "../../../../styled/setting";
import { toast } from "react-toastify";
import Info from "../../../common/info";
import useOutsideClick from "../../../../../../../../hooks/useOutsideClick";
import ActionButtons from "../../../common/actionButtons";
import Search from "../../../common/search";
import {
  formatQuantity,
  productDisplayState,
  productQuantityState,
} from "../../../../function/store";

const ProductList = ({
  products,
  clickAdd,
  toggleCheck,
  toggleAllCheck,
  data,
  clickImages,
  context,
  setContext,
  changeStatus,
  changeTab,
  isDelete,
  checked,
  setSearched,
  searched,
  searchProduct,
  isUpdate,
  menuGroup,
}) => {
  return (
    <ProductListContainer>
      <Info
        message={`등록한 상품 **${products.length}**개`}
        actions={[
          data.length > 0 && {
            label: checked.length === data.length ? "선택해제" : "전체선택",
            func: toggleAllCheck,
            key: "toggle",
          },
          menuGroup && { label: "연동", func: isUpdate, key: "sync" },
          { label: "추가", func: clickAdd, key: "add" },
          data.length > 0 && {
            label: "삭제",
            func: () => {
              if (!checked) {
                toast.error("상품을 선택해주세요.");
                return;
              }
              isDelete(checked);
            },
            key: checked.length > 0 ? "delete" : "undelete",
          },
        ].filter(Boolean)}
      />
      <div className="contents">
        <Search
          searched={searched}
          setSearched={setSearched}
          searchEvent={searchProduct}
          placeholder="상품명을 입력해주세요."
        />
        <ul>
          {data.map((item) => (
            <li key={item.id}>
              <CustomLabel>
                <input
                  type="checkbox"
                  checked={checked.includes(String(item.id))}
                  onChange={(e) => toggleCheck(item)}
                />
                <div className="checkmark"></div>
              </CustomLabel>
              <img
                onClick={() => clickImages(item.media, 0)}
                src={imgHandler(item.media)}
                alt={item.name}
                onError={(e) => (e.target.src = "/img/icon_function_4.png")}
                className={productQuantityState(item)?.status}
              />
              <div className="productInfo">
                <div className="tags">
                  <span className={item?.useDisplay ? "active" : "inactive"}>
                    {productDisplayState(item)}
                  </span>
                  <span className="id">상품코드 {item.cloudProduct.id}</span>
                </div>
                <span>{item.name}</span>
                <span>재고 {formatQuantity(item.quantity)}</span>
                <span>{item?.price ? `${formatNumber(item.price)}원` : "가격미정"}</span>
              </div>
              <ActionButtons
                context={context}
                setContext={setContext}
                item={item}
                highlight={false}
                changeStatus={changeStatus}
                parentId="product"
                buttons={[
                  { label: "자세히보기", onClick: () => changeTab(1, item) },
                  { label: "수정", onClick: () => changeTab(2, item) },
                  { label: "삭제", onClick: () => isDelete([item.id]) },
                ]}
              />
            </li>
          ))}
        </ul>
      </div>
    </ProductListContainer>
  );
};

export default ProductList;
